import React from "react";
import { useFormik } from "formik";
import {
  useSaveInsuranceMutation,
  useCompleteInsuranceMutation,
} from "state/api";
import { Button, Divider, MenuItem, Select, TextField } from "@mui/material";
import {
  insuranceStageDropdown,
  insuranceStatusDropdown0,
  insuranceStatusDropdown1,
  insuranceStatusDropdown2,
  insuranceStatusDropdown3,
} from "./insuranceDropdown";
import DisplayCard from "./DisplayCard";
import { MuiFileInput } from "mui-file-input";
import Timeline from "./Timeline";

const Insurance = ({ data, setLoader }) => {
  const [saveInsurance] = useSaveInsuranceMutation();
  const [completeInsurance] = useCompleteInsuranceMutation();

  const formik = useFormik({
    initialValues: {
      followUpDate:
        new Date().toISOString().slice(0, 11) +
        new Date().toLocaleTimeString().slice(0, 5),
      followUpStage:
        data?.insurance?.followUps[-1]?.followUpStage ||
        insuranceStageDropdown[0],
      followUpStatus:
        data?.insurance?.followUps[-1]?.followUpStatus ||
        insuranceStatusDropdown0[0],
      followUpRemarks: "",
      insuranceFile: null,
    },
    onSubmit: (values) => {
      values.transactionId = data._id;

      const formData = new FormData();
      formData.append("transactionId", values.transactionId);
      formData.append("followUpDate", values.followUpDate);
      formData.append("followUpStage", values.followUpStage);
      formData.append("followUpStatus", values.followUpStatus);
      formData.append("followUpRemarks", values.followUpRemarks);
      formData.append("insuranceFile", values.insuranceFile);

      setLoader(true);
      saveInsurance(formData)
        .unwrap()
        .then((res) => {
          alert("Insurance Status Updated");
          setLoader(false);
        })
        .catch((err) => {
          alert("Insurance Status Update Failed");
          setLoader(false);
        });
    },
  });

  const handleComplete = () => {
    setLoader(true);
    completeInsurance({
      transactionId: data?._id,
      insuranceId: data?.insurance?._id,
    })
      .unwrap()
      .then((res) => {
        alert("Insurance Completed");
        setLoader(false);
        window.location.reload();
      })
      .catch((err) => {
        alert("Insurance Completion Failed");
        setLoader(false);
      });
  };

  return (
    <>
      <div className="my-2 text-lg font-bold text-gray-700">Insurance</div>
      <DisplayCard data={data} />
      <form onSubmit={formik.handleSubmit}>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <TextField
            id="followUpDate"
            name="followUpDate"
            label="Date Time"
            type="datetime-local"
            value={formik.values.followUpDate}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="followUpRemarks"
            name="followUpRemarks"
            label="Remarks"
            type="text"
            value={formik.values.followUpRemarks}
            onChange={formik.handleChange}
            fullWidth
          />
          <Select
            id="followUpStage"
            name="followUpStage"
            value={formik.values.followUpStage}
            label="Stage"
            onChange={formik.handleChange}
            fullWidth
          >
            {insuranceStageDropdown.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
          <Select
            id="followUpStatus"
            name="followUpStatus"
            label="Status"
            value={formik.values.followUpStatus}
            onChange={formik.handleChange}
            fullWidth
          >
            {formik.values.followUpStage === insuranceStageDropdown[0] &&
              insuranceStatusDropdown0.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            {formik.values.followUpStage === insuranceStageDropdown[1] &&
              insuranceStatusDropdown1.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            {formik.values.followUpStage === insuranceStageDropdown[2] &&
              insuranceStatusDropdown2.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}

            {formik.values.followUpStage === insuranceStageDropdown[3] &&
              insuranceStatusDropdown3.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
          </Select>
          <MuiFileInput
            id="insuranceFile"
            name="insuranceFile"
            label="Insurance File"
            value={formik.values.insuranceFile}
            onChange={(value) => {
              formik.setFieldValue("insuranceFile", value);
            }}
            fullWidth
          />
        </div>
        <div className="flex flex-row gap-2">
          <Button
            type="submit"
            className="my-4 bg-slate-600 hover:bg-slate-700 text-white w-24"
          >
            Update
          </Button>
          <Button
            type="button"
            className="my-4 bg-red-600 hover:bg-red-700 text-white "
            onClick={handleComplete}
          >
            Mark as Complete
          </Button>
        </div>
      </form>
      <Divider />
      <Timeline data={data} />
    </>
  );
};

export default Insurance;
